import { IconSVG } from '../types';

export const FullscreenExit = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      style={style}
    >
      <path
        fill="currentColor"
        d="M6 18H4a.967.967 0 01-.712-.288A.968.968 0 013 17c0-.283.096-.52.288-.712A.967.967 0 014 16h3c.283 0 .52.096.713.288.191.191.287.429.287.712v3c0 .283-.096.52-.287.712A.967.967 0 017 21a.967.967 0 01-.713-.288A.968.968 0 016 20v-2zm12 0v2c0 .283-.096.52-.288.712A.968.968 0 0117 21a.968.968 0 01-.712-.288A.968.968 0 0116 20v-3c0-.283.096-.52.288-.712A.968.968 0 0117 16h3c.283 0 .52.096.712.288.192.191.288.429.288.712s-.096.52-.288.712A.968.968 0 0120 18h-2zM6 6V4c0-.283.096-.52.287-.712A.968.968 0 017 3c.283 0 .52.096.713.288.191.191.287.429.287.712v3c0 .283-.096.52-.287.713A.968.968 0 017 8H4a.968.968 0 01-.712-.287A.968.968 0 013 7c0-.283.096-.52.288-.713A.968.968 0 014 6h2zm12 0h2c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0120 8h-3a.968.968 0 01-.712-.287A.967.967 0 0116 7V4c0-.283.096-.52.288-.712A.968.968 0 0117 3c.283 0 .52.096.712.288.192.191.288.429.288.712v2z"
      />
    </svg>
  );
};
